import { Badge } from '../../ui/primitives/Badge.tsx';
import { Surface } from '../../ui/primitives/Surface.tsx';
import { Text } from '../../ui/primitives/Text.tsx';
import styles from './CompletionStates.module.css';

/**
 * FR-036, FR-054 (T076) — every available Exercise is done.
 *
 * Three claims this screen has to make, because each has a failure mode the
 * learner would otherwise assume:
 *
 *  - The content ran out; the app did not break. An empty practice screen
 *    reads as a bug unless it says otherwise.
 *  - The SESSION IS STILL ACTIVE (FR-058). Nothing in this release ends one,
 *    running out of content included, so this is a resting state and not a
 *    finish line — there is nothing to restart when new content lands.
 *  - Everything already completed is still theirs (FR-062). Completion is
 *    derived from permanent records, so this screen is not a reset.
 *
 * What it deliberately does NOT offer is a way to practise again from HERE.
 * "Again" is a question about a particular Lesson — which one do you want to
 * do over — and this screen is the one place in the product that is about no
 * Lesson in particular. The journey answers it instead: every finished Lesson
 * on the spine opens its own review, and the review is where the run starts
 * over (`features/content/LessonReview.tsx`).
 *
 * The permanence claim above survives that. Restarting supersedes attempts
 * rather than deleting them and drops only `exercise_completion`, which is a
 * derived "this is behind me" and not a record of anything the learner did —
 * so everything already answered is still theirs, as this screen says.
 */
export function AllComplete() {
  return (
    <Surface as="section" layer={2} radius="xl" inset>
      <div className={styles.state} data-testid="all-complete">
        <Badge tone="success" icon="check">
          Tudo concluído
        </Badge>
        <Text as="h1" variant="heading">
          Você concluiu todo o conteúdo disponível
        </Text>
        <Text as="p" variant="body">
          Sua prática continua ativa — não há nada para reiniciar. Assim que um novo exercício
          for publicado, ele aparece aqui e você retoma de onde parou.
        </Text>
        <Text as="p" variant="body-sm" tone="muted">
          Tudo o que você já respondeu continua registrado.
        </Text>
      </div>
    </Surface>
  );
}
